import { Injectable } from '@angular/core';
import * as parser from 'cron-parser';
import {AutomationSettings, SyncJobSchedule} from '../../modules/roster-sync-job/interfaces/roster-sync-jobs.model';
import {GuardianAutomationSettings} from '../../modules/guardians/interfaces/guardian-sync.model';

@Injectable({
  providedIn: 'root'
})
export class DateTimeUtilsService {

  constructor() { }

  hourMinsFrom12hr = (time12h) => {
    const [time, ampm] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = 0;
    }

    if (ampm === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }

    return [hours, minutes];
  };

  _calculateNextExecution = (automation: AutomationSettings | GuardianAutomationSettings) => {
    let next;
    try {
      const [hour, mins] = this.hourMinsFrom12hr(automation.schedule.time);
      let cronString = `0 ${mins} ${hour} * * `;

      const dow = {
        mon: 1,
        tue: 2,
        wed: 3,
        thu: 4,
        fri: 5,
        sat: 6,
        sun: 7
      };

      const dayString = Object.keys(automation.schedule.dow).reduce((days, shortDay) => {
        if (automation.schedule.dow[shortDay]) {
          days.push(dow[shortDay]);
        }
        return days;
      }, []);

      cronString += dayString.join(',');
      const cron = parser.parseExpression(cronString);
      next = cron.next().toDate();
    } catch (e) {
      console.warn(`Error calculating automation DT - ${e.message}`);
    }

    return next;
  };

  dateStringToTimestamp = (dateString: string): number => {
    return new Date(dateString).getTime();
  };
}
